import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import {
    ApiService,
    CountryListService,
    DialogService,
    InputDatastoreService,
    ValuesExchangeProvider
} from '@nrwl/common-lib';
import { BaseWizardService } from '../base.wizard.service';
import { LdapServerWizardStep } from './ldap.server.step';

@Injectable()
export class LdapConfigWizardService extends BaseWizardService {
    openNew: boolean;
    state: ActivatedRoute;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    currentParam: any;
    closeWizard: BehaviorSubject<boolean>;

    constructor(
        dataApiService: ApiService,
        state: ActivatedRoute,
        inputDatastoreService: InputDatastoreService,
        countryListService: CountryListService,
        dialogService: DialogService,
        private readonly valuesExchange: ValuesExchangeProvider
    ) {
        super(dataApiService, inputDatastoreService, countryListService, dialogService);
        this.state = state;
        this.stepClass = LdapServerWizardStep;
        this.openNew = false;
        this.closeWizard = new BehaviorSubject(false);
    }

    //------------------------------------------------ Wizard control ----------------------------------------------------

    openWizard(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
        wizardId: any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
        wizardConfig: any,
        defaultParamsById = {},
        onSuccess = () => { },
        onFail = () => { }
    ): void {
        super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
        if (this.editMode) {
            this._setOutputForEditMode(defaultParamsById);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    _setDefaultParams(step: any, targetOutput: any, defaultParamsById: any = {}): void {
        super._setDefaultParams(step, targetOutput, defaultParamsById);
    }

    setNextStep(): void {
        super.setNextStep();
    }

    _setPreviousStep(): void {
        super._setPreviousStep();
    }

    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    onFinish(): any {
        this.currentStep.onNext();
        this.dirtyFlag = false;
        let output = this._getFormatOutput();
        output = this.processFinalOutput(output);
        if (this.editMode) {
            this.method = 'put';
            this.dataUrl = '/ims/v2/configuration/auth-providers/ldap/' + this.defaultParamsById.id;
        }

        const responseProcessed = this._saveRequest(output, false);
        responseProcessed.subscribe(() => {
            this.currentStep = this.finishingStep;
            if (!this.requestFailed) {
                this.valuesExchange.notifyListeners('ldap_server_update', {
                    value: 'update',
                    cacheBreaker: Date.now()
                });
                this.successMessage = !this.editMode
                    ? 'LDAP server configuration has been successfully added'
                    : 'LDAP server configuration has been successfully updated';
            }
        });
        return responseProcessed;
    }

    showExitInsteadOfClose(): boolean {
        if (this.isFinishingStep() && (this.requestFailed || this.errorMessage)) {
            return true;
        }
        return false;
    }
    //eslint-disable-next-line
    processFinalOutput(output: any): any {
        return {
            "servers": this.createServerArray(output.servers),
            "bindDN": output.bindDN ? output.bindDN : "",
            "bindPassword": output.bindPassword ? output.bindPassword : "",
            "attributeNames": {
                "usernameAttribute": output.usernameAttribute,
                "groupNameAttribute": output.groupNameAttribute,
                "nameAttribute": output.nameAttribute,
                "surnameAttribute": output.surnameAttribute,
                "emailAttribute": output.emailAttribute,
                "membershipAttribute": output.membershipAttribute,
                "groupMembershipAttribute": output.groupMembershipAttribute
            },
            "usersFilter": output.usersFilter,
            "groupsFilter": output.groupsFilter ? output.groupsFilter : "",
            "groupFilterBy": output.groupFilterBy,
            "anonymous": output.anonymousBind ? output.anonymousBind : false,
            "tls": false,
            "trustAnyCert": output.trustSSLCertificate ? output.trustSSLCertificate : false,
            "trustCertificate": output.trustCertificate ? output.trustCertificate : "",
            "userSearchBase": output.baseDN,
            "groupSearchBase": output.groupBaseDN ? output.groupBaseDN : ""
        };
    }
    //eslint-disable-next-line
    createServerArray(servers): any {
        //eslint-disable-next-line
        let result = [];
        servers.split(',').forEach(item => {
            const server = item.split(':');
            result.push({ "hostname": server[0], "port": Number(server[1]) });
        });
        return result;
    }
}